export default new Intl.NumberFormat('nl-NL').format;

export const numberFormatFixedTwo = new Intl.NumberFormat('nl-NL', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
}).format;
